import React from "react";

/**
 * @component DiscussionAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <DiscussionAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DiscussionAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DiscussionAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M22 13v9l-4-4H8a2 2 0 01-1.995-1.85L6 16v-1h10a3.001 3.001 0 002.829-2H22zM12 2v2H4v8.17L5.17 11H16l.001 1.732a1.987 1.987 0 01-.82.26L15 13H6l-4 4V4a2 2 0 011.85-1.995L4 2h8zm7 0v3h3v2h-3v3h-2V6.999L14 7V5l3-.001V2h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DiscussionAddIcon.displayName = "DiscussionAddIcon";
export default DiscussionAddIcon;
